var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"backdrop"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"height":"100px","width":"100px","src":require("@/assets/clock.svg"),"alt":"Loading"}})])
}]

export { render, staticRenderFns }